module.exports = __webpack_public_path__ + "img/thingworx_logo.ed8fa944.svg";